import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/lib/i18n";
import { ProtectedRoute, RoleRedirect } from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Onboarding from "@/pages/Onboarding";
import SuperAdminInstitutes from "@/pages/SuperAdminInstitutes";
import InstituteCoaches from "@/pages/InstituteCoaches";
import CoachUsers from "@/pages/CoachUsers";
import QualityOfLife from "@/pages/QualityOfLife";
import Dashboard from "@/pages/Dashboard";
import BrainType from "@/pages/BrainType";
import UpcomingEvents from "@/pages/UpcomingEvents";
import InstituteSettings from "@/pages/InstituteSettings";
import Account from "@/pages/Account";
import InstituteDetail from "@/pages/InstituteDetail";
import CoachDetail from "@/pages/CoachDetail";
import UserDetail from "@/pages/UserDetail";
import GotPractice from "@/pages/GotPractice";
import Manual from "@/pages/Manual";
import { Toaster } from "@/components/ui/sonner";

const withLayout = (children) => (
  <AppLayout>{children}</AppLayout>
);

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route
              path="/onboarding"
              element={
                <ProtectedRoute roles={["user"]}>
                  <Onboarding />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/institutes"
              element={
                <ProtectedRoute roles={["super_admin"]}>
                  {withLayout(<SuperAdminInstitutes />)}
                </ProtectedRoute>
              }
            />

            <Route
              path="/institute/coaches"
              element={
                <ProtectedRoute roles={["institute_admin"]}>
                  {withLayout(<InstituteCoaches />)}
                </ProtectedRoute>
              }
            />

            <Route
              path="/coach/users"
              element={
                <ProtectedRoute roles={["coach"]}>
                  {withLayout(<CoachUsers />)}
                </ProtectedRoute>
              }
            />

            <Route
              path="/me/dashboard"
              element={
                <ProtectedRoute roles={["user"]}>
                  {withLayout(<Dashboard />)}
                </ProtectedRoute>
              }
            />

            <Route
              path="/me/quality-of-life"
              element={
                <ProtectedRoute roles={["user"]}>
                  {withLayout(<QualityOfLife />)}
                </ProtectedRoute>
              }
            />

            <Route
              path="/me/brain-type"
              element={
                <ProtectedRoute roles={["super_admin", "institute_admin", "coach", "user"]}>
                  {withLayout(<BrainType />)}
                </ProtectedRoute>
              }
            />

            <Route
              path="/me/upcoming-events"
              element={
                <ProtectedRoute roles={["super_admin", "institute_admin", "coach", "user"]}>
                  {withLayout(<UpcomingEvents />)}
                </ProtectedRoute>
              }
            />

            <Route
              path="/me/account"
              element={
                <ProtectedRoute roles={["super_admin", "institute_admin", "coach", "user"]}>
                  {withLayout(<Account />)}
                </ProtectedRoute>
              }
            />

            <Route
              path="/me/got-practice"
              element={
                <ProtectedRoute roles={["coach", "user"]}>
                  {withLayout(<GotPractice />)}
                </ProtectedRoute>
              }
            />

            <Route
              path="/me/manual"
              element={
                <ProtectedRoute roles={["coach", "user"]}>
                  {withLayout(<Manual />)}
                </ProtectedRoute>
              }
            />

            <Route
              path="/institute/settings"
              element={
                <ProtectedRoute roles={["institute_admin"]}>
                  {withLayout(<InstituteSettings />)}
                </ProtectedRoute>
              }
            />

            <Route
              path="/details/institute/:id"
              element={
                <ProtectedRoute roles={["super_admin"]}>
                  {withLayout(<InstituteDetail />)}
                </ProtectedRoute>
              }
            />

            <Route
              path="/details/coach/:id"
              element={
                <ProtectedRoute roles={["super_admin", "institute_admin"]}>
                  {withLayout(<CoachDetail />)}
                </ProtectedRoute>
              }
            />

            <Route
              path="/details/user/:id"
              element={
                <ProtectedRoute roles={["super_admin", "institute_admin", "coach"]}>
                  {withLayout(<UserDetail />)}
                </ProtectedRoute>
              }
            />

            <Route path="/" element={<RoleRedirect />} />
            <Route path="*" element={<RoleRedirect />} />
          </Routes>
        </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
      <Toaster richColors closeButton position="top-right" />
    </div>
  );
}

export default App;
